// Country list + ISO mapping for the address step (reference data).
// Countries with ISO codes for localization via Intl.DisplayNames
const COUNTRY_VALUE_TO_ISO: Record<string, string> = {
  Germany: 'DE', Austria: 'AT', Switzerland: 'CH',
  Albania: 'AL', Andorra: 'AD', Belgium: 'BE',
  'Bosnia and Herzegovina': 'BA', Bulgaria: 'BG', Denmark: 'DK',
  Estonia: 'EE', Finland: 'FI', France: 'FR',
  Greece: 'GR', Ireland: 'IE', Iceland: 'IS',
  Italy: 'IT', Kosovo: 'XK', Croatia: 'HR',
  Latvia: 'LV', Liechtenstein: 'LI', Lithuania: 'LT',
  Luxembourg: 'LU', Malta: 'MT', Moldova: 'MD',
  Monaco: 'MC', Montenegro: 'ME', Netherlands: 'NL',
  'North Macedonia': 'MK', Norway: 'NO', Poland: 'PL',
  Portugal: 'PT', Romania: 'RO', 'San Marino': 'SM',
  Sweden: 'SE', Serbia: 'RS', Slovakia: 'SK',
  Slovenia: 'SI', Spain: 'ES', 'Czech Republic': 'CZ',
  Hungary: 'HU', 'United Kingdom': 'GB', Ukraine: 'UA',
  Belarus: 'BY', Cyprus: 'CY',
  Australia: 'AU', Brazil: 'BR', China: 'CN',
  India: 'IN', Japan: 'JP', Canada: 'CA',
  Russia: 'RU', 'South Africa': 'ZA', 'South Korea': 'KR',
  Turkey: 'TR', 'United Arab Emirates': 'AE', 'United States': 'US',
}

/** ISO 3166-1 alpha-2 of a stored country value ('Germany' → 'DE'); null for 'Other' / unknown. */
export function countryIso(value: string | null | undefined): string | null {
  if (!value) return null
  if (/^[A-Z]{2}$/.test(value)) return value
  return COUNTRY_VALUE_TO_ISO[value] ?? null
}

export function buildCountriesList(locale: string, otherLabel: string): { value: string; label: string }[] {
  let displayNames: Intl.DisplayNames
  try {
    displayNames = new Intl.DisplayNames([locale], { type: 'region' })
  } catch {
    displayNames = new Intl.DisplayNames(['en'], { type: 'region' })
  }

  // Pinned top countries (order preserved)
  const pinned = ['Germany', 'Austria', 'Switzerland']
  const rest = Object.keys(COUNTRY_VALUE_TO_ISO).filter(v => !pinned.includes(v))

  const resolve = (value: string) => {
    const iso = COUNTRY_VALUE_TO_ISO[value]
    return { value, label: (iso && displayNames.of(iso)) || value }
  }

  const pinnedEntries = pinned.map(resolve)
  const restEntries = rest.map(resolve).sort((a, b) => a.label.localeCompare(b.label, locale))

  return [...pinnedEntries, ...restEntries, { value: 'Other', label: otherLabel }]
}
